import { AlgoliaReviewsSchema } from '@jane/search/types';
import type { AlgoliaReview, CurrentSort } from '@jane/search/types';

import { search } from './search';

interface SearchProductReviewParams {
  currentSort?: CurrentSort;
  searchOptions: {
    facetFilters?: string[];
    facets?: string[];
    hitsPerPage?: number;
    numericFilters?: string[];
    page?: number;
  };
}

export const searchProductReviews = async ({
  currentSort,
  searchOptions: options,
}: SearchProductReviewParams) => {
  return await search<AlgoliaReview>(
    {
      indexPrefix: 'product-reviews-',
      options,
      currentSort: currentSort,
    },
    AlgoliaReviewsSchema
  );
};
